const translations = {
  de: {
    nav: {
      home: 'Startseite',
      schedule: 'Termin buchen',
      admin: 'Admin',
      language: 'EN',
    },
    home: {
      heroTitle: 'Zeig mir deine Füße!',
      heroSubtitle: 'Körperarbeit nach der Grinberg Methode',
      scheduleNow: 'Jetzt Termin buchen',
      aboutText: 'Durch Zufall erhielt ich vor einigen Jahren meine erste Grinberg-Sitzung – ohne wirklich zu wissen, was das genau ist. Bereits am Nachhauseweg war ich ohne jegliche Anspannung. Ich realisierte, dass ich im Alltag dauerhaft angespannt bin. Einige Jahre später sehnte ich mich nach dem Gefühl zurück, das die damalige Behandlung ausgelöst hatte. Nach einigen lehrreichen Sitzungen spürte ich mich wieder. Mit Begeisterung darf nun auch ich andere auf ihrem Weg zu sich selbst begleiten.',
    },
    contact: {
      title: 'Kontakt',
      contact: 'Du kannst mich per E-Mail kontaktieren:',
      email: 'blau.body@gmail.com',
    },
    schedule: {
      title: 'Termin buchen',
      selectDate: 'Datum auswählen',
      selectTime: 'Uhrzeit auswählen',
      appointmentType: 'Terminart auswählen',
      firstAppointment: 'Erste Sitzung: Fußanalyse inklusive Wissensgespräch (1,5 Stunden)',
      followUpAppointment: 'Einzelsitzung (1 Stunde)',
      personalInfo: 'Persönliche Informationen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      notes: 'Notizen für Hannah',
      discountCode: 'Rabattcode',
      captcha: 'Captcha bestätigen',
      bookAppointment: 'Termin buchen',
      confirmationTitle: 'Termin bestätigt!',
      confirmationText: 'Ihr Termin wurde erfolgreich gebucht. Sie erhalten eine Bestätigungs-E-Mail.',
      modifyAppointment: 'Termin ändern',
      cancelAppointment: 'Termin absagen',
      noSlotsAvailable: 'Keine Termine verfügbar',
      loadingSlots: 'Termine werden geladen...',
      checkEmail: 'E-Mail prüfen',
      requestSent: 'Terminanfrage gesendet',
      confirmationRequired: 'E-Mail-Bestätigung erforderlich',
      emailSentTo: 'Wir haben eine Bestätigungs-E-Mail gesendet an:',
      checkEmailInstructions: 'Bitte prüfen Sie Ihre E-Mails und klicken Sie auf den Bestätigungslink, um Ihren Termin zu sichern. Ohne Bestätigung bleibt der Zeitslot für andere verfügbar.',
      appointmentDetails: 'Angefragter Termin',
      date: 'Datum',
      time: 'Zeit',
      name: 'Name',
      pendingStatus: 'Status: Warten auf Bestätigung',
      bookAnother: 'Weiteren Termin buchen',
      backToHome: 'Zurück zur Startseite',
    },
    confirmation: {
      title: 'Termin bestätigt!',
      cancelled: 'Termin abgesagt',
      confirmedText: 'Ihr Termin wurde erfolgreich bestätigt.',
      cancelledText: 'Ihr Termin wurde abgesagt.',
      loadingDetails: 'Termindetails werden geladen...',
      appointmentDetails: 'Termindetails',
      dateTime: 'Datum & Zeit',
      duration: 'Dauer: 90 Minuten',
      address: 'Adresse',
      clientInfo: 'Kundeninformation',
      messageNotes: 'Nachricht/Notizen',
      status: 'Status',
      confirmed: 'Bestätigt',
      needChanges: 'Änderungen nötig?',
      contactWithin24h: 'Änderungen innerhalb von 24 Stunden: Bitte kontaktieren Sie Hannah direkt für Änderungen oder Absagen.',
      email: 'E-Mail',
      phone: 'Telefon',
      backToHome: 'Zurück zur Startseite',
      cancelDialogTitle: 'Termin absagen',
      cancelDialogText: 'Sind Sie sicher, dass Sie Ihren Termin am {date} um {time} absagen möchten?',
      cancelReason: 'Grund für Absage (optional)',
      keepAppointment: 'Termin beibehalten',
      hoursUntil: '{hours} Stunden bis zum Termin',
      daysUntil: '{days} Tage bis zum Termin',
      appointmentPassed: 'Termin ist vorbei',
      notFound: 'Termin nicht gefunden. Bitte überprüfen Sie Ihre Termin-ID.',
      noIdProvided: 'Keine Termin-ID in der URL angegeben',
      loadError: 'Fehler beim Laden der Termindetails: {error}',
      cancelError: 'Fehler beim Absagen des Termins: {error}',
      pendingText: 'Ihr Termin wartet auf Bestätigung per E-Mail.',
      pendingInstructions: 'Bitte prüfen Sie Ihre E-Mails und klicken Sie auf den Bestätigungslink. Ohne Bestätigung bleibt Ihr Zeitslot für andere verfügbar.',
      confirmingAppointment: 'Termin wird bestätigt...',
      confirmationSuccess: 'Ihr Termin wurde erfolgreich bestätigt!',
      alreadyConfirmed: 'Ihr Termin ist bereits bestätigt.',
      confirmationError: 'Fehler bei der Terminbestätigung: {error}',
    },
    admin: {
      title: 'Admin Dashboard',
      login: 'Mit Google anmelden',
      logout: 'Abmelden',
      calendar: 'Kalender',
      appointments: 'Termine',
      availability: 'Verfügbarkeit',
      createSlot: 'Zeitslot erstellen',
      viewAppointments: 'Termine anzeigen',
      cancelAppointment: 'Termin absagen',
      reason: 'Grund',
      notifyClient: 'Kunde benachrichtigen',
      unauthorized: 'Nicht autorisiert',
    },
    footer: {
      copyright: '© Hannah Blau 2025',
      legal: 'Impressum',
    },
    common: {
      loading: 'Wird geladen...',
      error: 'Ein Fehler ist aufgetreten',
      success: 'Erfolgreich',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      back: 'Zurück',
      next: 'Weiter',
      submit: 'Absenden',
    },
    
    legal: {
      disclaimer: 'Die Grinberg Methode ist eine Methodik der Aufmerksamkeit, die durch die Erweiterung und Fokussierung der Körperaufmerksamkeit lehrt. Sie erhebt keinen Anspruch darauf, zu heilen, eine Alternativmedizin oder Massagetherapie zu sein oder zu den helfenden Berufen zu gehören. Sie ist weder für Menschen bestimmt, die an einer Krankheit leiden, die als lebensbedrohlich gilt, noch eignet sie sich bei ernsten Erkrankungen oder Beschwerden, die eine medizinische oder psychiatrische Behandlung erfordern. Sie kann keinerlei notwendige Behandlung ersetzen. Die Methode hat keine ideologischen oder mystischen Grundlagen und erfordert keine bestimmte Lebensführung.',
    },
  },
  en: {
    nav: {
      home: 'Home',
      schedule: 'Schedule',
      admin: 'Admin',
      language: 'DE',
    },
    legal: {
      disclaimer: 'The Grinberg Method is a methodology of attention that teaches through expanding and focusing body attention. It does not claim to heal, to be an alternative medicine, a massage therapy, or to be considered among the helping professions. It is not intended for persons suffering from conditions considered life threatening. Nor for those with conditions or serious illnesses that require medical or psychiatric attention. Moreover, it is not intended to be a substitute for any kind of required treatment. The method has no ideological or mystical basis and does not demand any particular lifestyle.',
    },
    contact: {
      title: 'Contact',
      contact: 'You can contact me via email:',
      email: 'blau.body@gmail.com',
    },
    home: {
      heroTitle: 'Show me your feet!',
      heroSubtitle: 'Body work by the Grinberg Method',
      scheduleNow: 'Schedule now',
      aboutText: 'By chance, I received my first Grinberg session a few years ago – without really knowing what it was exactly. Already on my way home, I was without any tension. I realized that I am constantly tense in everyday life. A few years later, I longed for the feeling that the treatment had triggered back then. After some instructive sessions, I felt myself again. With enthusiasm, I too am now able to accompany others on their journey to themselves.',
    },
    schedule: {
      title: 'Schedule Appointment',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      personalInfo: 'Personal Information',
      firstName: 'First Name',
      appointmentType: 'Appointment Type',
      firstAppointment: 'First Session: Foot Analysis including Knowledge Session (1.5 hours)',
      followUpAppointment: 'Single Session (1 hour)',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone Number',
      notes: 'Notes for Hannah',
      discountCode: 'Discount Code',
      captcha: 'Verify Captcha',
      bookAppointment: 'Book Appointment',
      confirmationTitle: 'Appointment Confirmed!',
      confirmationText: 'Your appointment has been successfully booked. You will receive a confirmation email.',
      modifyAppointment: 'Modify Appointment',
      cancelAppointment: 'Cancel Appointment',
      noSlotsAvailable: 'No appointments available',
      loadingSlots: 'Loading appointments...',
      checkEmail: 'Check Your Email',
      requestSent: 'Appointment Request Sent',
      confirmationRequired: 'Email Confirmation Required',
      emailSentTo: 'We have sent a confirmation email to:',
      checkEmailInstructions: 'Please check your email and click the confirmation link to secure your appointment. Without confirmation, the time slot remains available for others.',
      appointmentDetails: 'Requested Appointment',
      date: 'Date',
      time: 'Time',
      name: 'Name',
      pendingStatus: 'Status: Pending confirmation',
      bookAnother: 'Book Another Appointment',
      backToHome: 'Back to Home',
    },
    confirmation: {
      title: 'Appointment Confirmed!',
      cancelled: 'Appointment Cancelled',
      confirmedText: 'Your appointment has been successfully confirmed.',
      cancelledText: 'Your appointment has been cancelled.',
      loadingDetails: 'Loading appointment details...',
      appointmentDetails: 'Appointment Details',
      dateTime: 'Date & Time',
      duration: 'Duration: 90 minutes',
      address: 'Address',
      clientInfo: 'Client Information',
      messageNotes: 'Message/Notes',
      status: 'Status',
      confirmed: 'Confirmed',
      needChanges: 'Need to make changes?',
      contactWithin24h: 'Changes within 24 hours: Please contact Hannah directly for any changes or cancellations.',
      email: 'Email',
      phone: 'Phone',
      backToHome: 'Back to Home',
      cancelDialogTitle: 'Cancel Appointment',
      cancelDialogText: 'Are you sure you want to cancel your appointment on {date} at {time}?',
      cancelReason: 'Reason for cancellation (optional)',
      keepAppointment: 'Keep Appointment',
      hoursUntil: '{hours} hours until appointment',
      daysUntil: '{days} days until appointment',
      appointmentPassed: 'Appointment time has passed',
      notFound: 'Appointment not found. Please check your appointment ID.',
      noIdProvided: 'No appointment ID provided in URL',
      loadError: 'Failed to load appointment details: {error}',
      cancelError: 'Failed to cancel appointment: {error}',
      pendingText: 'Your appointment is waiting for email confirmation.',
      pendingInstructions: 'Please check your email and click the confirmation link. Without confirmation, your time slot remains available for others.',
      confirmingAppointment: 'Confirming appointment...',
      confirmationSuccess: 'Your appointment has been confirmed successfully!',
      alreadyConfirmed: 'Your appointment is already confirmed.',
      confirmationError: 'Error confirming appointment: {error}',
    },
    admin: {
      title: 'Admin Dashboard',
      login: 'Sign in with Google',
      logout: 'Sign out',
      calendar: 'Calendar',
      appointments: 'Appointments',
      availability: 'Availability',
      createSlot: 'Create Time Slot',
      viewAppointments: 'View Appointments',
      cancelAppointment: 'Cancel Appointment',
      reason: 'Reason',
      notifyClient: 'Notify Client',
      unauthorized: 'Unauthorized',
    },
    footer: {
      copyright: '© Hannah Blau 2025',
      legal: 'Legal',
    },
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
    },
  },
};

export default translations; 